// @flow
import { styled } from 'mz-ui-kit';
import { getScreenStyles } from 'mz-ui-kit/utils';

const imageStyle = {
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  width: '100%',
  height: '100%'
};

export const Container = styled('div', {
  ...imageStyle,
  height: 'initial',
  backgroundImage: `url(${require('./assets/bg.jpg')})`,
  backgroundSize: 'cover',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: '50px',
});

export const Row = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  maxWidth: '950px',
  padding: '60px 20px 20px 20px',
  ...getScreenStyles('sm', {
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 14%',
    padding: '20px'
  })
});

export const FeaturesColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '-40px',
  ...getScreenStyles('sm', {
    marginRight: '0',
    width: '100%',
    paddingTop: '20px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  ...getScreenStyles('xs', {
    paddingTop: '10px!important',
    justifyContent: 'space-around !important'
  })
});

export const Title = styled('h1', {
  color: 'white',
  maxWidth: '750px',
  fontSize: '34px',
  margin: '0 0 15px 0',
  ...getScreenStyles('xs', {
    fontSize: '24px',
    textAlign: 'center'
  })
});

export const FormSection = styled('div', {
  flexGrow: 1,
  maxWidth: '700px',
  width: '100%'
});
